import { withTitle } from '@gik/core/hocs/withTitle';
import { CompetitorsPage } from '@gik/marketing/pages/CompetitorsPage';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';

export default function CompetitorsPageComp() {
  return withTitle('Competitors', <CompetitorsPage />);
}

CompetitorsPageComp.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};
